;
export const SafeAreaInsetsChangeEventName = "safeAreaPluginsInsetChange";
